<template>
  <iColumn width="hug" gap="none">
    <!-- Single root (iIcon has inheritAttrs:false) so data-edit-identifier lands.
         Keep this comment INSIDE the root — leading it drops the attr in production only. -->
    <iIcon
      v-if="getOptionValue(Icon)"
      :icon="getOptionValue(Icon)"
      :name="getOptionValue(Icon)"
      :variant="getOptionValue(IconVariant)"
      :size="getOptionValue(IconSize)"
      :border-top="myBorderSides.top"
      :border-bottom="myBorderSides.bottom"
      :border-left="myBorderSides.left"
      :border-right="myBorderSides.right"
      disable-hover-effect
      :style-overrides="iconStyleOverrides"
    />
  </iColumn>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import Icon from "%/dynamic-component-editor/options/icon";
import IconVariant from "%/dynamic-component-editor/options/icon-variant";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import IconSize from "%/dynamic-component-editor/options/icon-size";
import IconOptions from "%/dynamic-component-editor/bundles/icon-options";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import BorderSides from "%/dynamic-component-editor/options/border-sides";
import BorderOptions from "%/dynamic-component-editor/bundles/border-options";
import TextShadow from "%/dynamic-component-editor/options/text-shadow";
import IconColor from "%/dynamic-component-editor/options/icon-color";

export default {
  name: "Icon",
  mixins: [DynamicElementMixin],
  elementPanelSettings: {
    tags: ["icon", "glyph", "symbol"],
    displayName: "Icon",
    displayIcon: "image",
    elementGroup: "general",
    elementType: "element",
  },
  data() {
    return {
      LayoutHeight,
      LayoutWidth,
      Icon,
      IconVariant,
      IconSize,
      TextShadow,
      BaseOption,
    };
  },
  optionBundles: [
    IconOptions,
    new EffectsOptions({}, {
      "box-shadow": true,
    }),
    BorderOptions,
  ],
  options: [
    new LayoutWidth({
      default: "hug",
    }, true),
    new LayoutHeight({
      default: "hug",
    }, true),
  ],
  computed: {
    myBorderSides() {
      return this.getOptionValue(BorderSides);
    },
    iconStyleOverrides() {
      const overrides = {
        textShadow: this.getOptionValue(TextShadow),
        textShadowHover: this.getOptionValue(TextShadow, BaseOption.$states.HOVER),
      };
      // The icon's colour follows the Icon Color option (its default = the
      // theme's standard font colour); apply it to the active variant's slot.
      const variant = this.getOptionValue(IconVariant) || "primary";
      overrides[`${variant}VariantColor`] = this.getOptionValue(IconColor);
      return overrides;
    },
  },
};
</script>
